import { render, staticRenderFns } from "./tradedetail.vue?vue&type=template&id=5a47a6a4&scoped=true"
import script from "./tradedetail.vue?vue&type=script&lang=js"
export * from "./tradedetail.vue?vue&type=script&lang=js"
import style0 from "./tradedetail.vue?vue&type=style&index=0&id=5a47a6a4&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a47a6a4",
  null
  
)

export default component.exports